module.exports = __webpack_public_path__ + "static/media/AB_ZW10_4.b6086524.jpg";